import '../../components/stageshow/stageshow.css';
import React from 'react';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SEO from '../../components/common/SEO';
import AdvisorChat from '../../components/advisor/AdvisorChat';
import { useAuth } from '../../contexts/AuthContext';
import { tokens as t } from '../../styles/appTheme';

const POINTS = [
  { title: 'Rates by address', body: 'Combined state, county, city and district rates for any ZIP code or city.' },
  { title: 'Product rules', body: 'Whether candy, groceries, clothing, diapers or software are taxed in a state, and why.' },
  { title: 'What is changing', body: 'Scheduled rate changes, tax-free holidays and new rules from state revenue departments.' },
];

/** Public Tax Advisor page (/products/advisor). Anyone can ask; signed-out use is rate limited. */
const AdvisorPage: React.FC = () => {
  const { isAuthenticated } = useAuth() as any;
  return (
    <Box sx={{ bgcolor: t.paper, minHeight: 'calc(100vh - 64px)' }}>
      <SEO title="Sales Tax Advisor | GoTruTax" description="Ask any US sales tax question: rates by ZIP, whether a product is taxable in a state, and upcoming rule changes. Answers cite the rule and date." canonical="https://gotrutax.com/products/advisor" />
      <Container maxWidth="md" sx={{ pt: { xs: 5, md: 8 }, pb: { xs: 6, md: 10 } }}>
        <Typography variant="h1" component="h1" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1.5, overflowWrap: 'break-word' }}>
          Ask any sales tax question
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 4, maxWidth: 620, fontSize: '1.0625rem' }}>
          Answers come from the same rate tables and product rules that power our tax engine, with the rule and date shown.
        </Typography>

        <div className="ss-frame" data-testid="advisor-frame">
          <div className="ss-chrome"><i /><i /><i /><span>Tax Advisor</span></div>
          <div className="ss-frame-body"><AdvisorChat autoFocus /></div>
        </div>

        <Box component="section" sx={{ mt: { xs: 6, md: 9 }, display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(3, minmax(0, 1fr))' }, gap: { xs: 3, md: 4 } }}>
          {POINTS.map((p) => (
            <Box key={p.title} className="ss-tile">
              <Typography variant="h6" component="h2" sx={{ mb: 0.5 }}>{p.title}</Typography>
              <Typography variant="body2" color="text.secondary">{p.body}</Typography>
            </Box>
          ))}
        </Box>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ sm: 'center' }} sx={{ mt: { xs: 5, md: 7 }, pt: 3, borderTop: `1px solid ${t.rule}` }}>
          <Typography variant="body1" sx={{ flex: 1 }}>
            Need this inside your checkout or accounting workflow?
          </Typography>
          <Button component={RouterLink} to="/developers" variant="outlined">Sales tax API</Button>
          {!isAuthenticated && <Button component={RouterLink} to="/get-started" variant="contained">Get started free</Button>}
        </Stack>
      </Container>
    </Box>
  );
};

export default AdvisorPage;
